import * as React from "react"
import "./styles.scss";
import ProductPassportDataCollapsable from "../ProductPassportData/Collapsable";
import { getLocalQueryParams, getQueryParams } from "../../lib/Misc";
import ProductImageSlider from "../ProductPassportData/content/ProductImageSlider";
import TextWithLinksParser from "../TextWithLinksParser";
import ProductPassportDataSection from "../ProductPassportData/Section";
import {useState} from "react";

export default function ProductPassport({
    isProductPassportView,
    productPassportDataCarousel,
    productPassportDataSection,
    productPassportDataHead,
    productLoaded,
    loading,
    setSelectedTab,
}) {
    const [isSectionOpen, setIsSectionOpen] = useState(false);

    const localParams = getLocalQueryParams();
    let queryParams = getQueryParams();
    queryParams = !!queryParams && !!queryParams?.code
        ? queryParams
        : typeof localParams !== 'string'
            ? localParams
            : {};

    const getCompositionData = (headItem) => {
        const compositions = [];

        if (headItem?.composition) {
            compositions.push({ label: 'Composition', value: headItem.composition });
        }

        if (headItem?.composition_main_fabric) {
            const fabricValue = headItem.composition_main_fabric;
            const hasSemicolon = fabricValue.includes(';');

            compositions.push({
                label: hasSemicolon ? 'Fabrics' : 'Fabric',
                value: hasSemicolon ? fabricValue.replace(/;\s*/g, ';\n') : fabricValue
            });
        }

        if (headItem?.composition_linings) {
            compositions.push({ label: 'Lining', value: headItem.composition_linings });
        }

        Object.keys(headItem || {}).forEach(key => {
            if (key.startsWith('composition_') &&
                key !== 'composition_main_fabric' &&
                key !== 'composition_linings' &&
                headItem[key]) {
                const label = key.replace('composition_', '').replace(/_/g, ' ')
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                compositions.push({ label: label, value: headItem[key] });
            }
        });

        return compositions.length > 0 ? compositions : null;
    };

    return (
        <div className={`product-passport`}>
            {!!productLoaded ? (
                loading ?
                    <div className="loading-section">
                        <div className="loader"></div>
                    </div> :
                    <>
                        {
                            !isSectionOpen ?
                                <div className={`product-passport-top-display`}>
                                    <div className={`image-bg`}>
                                        {productPassportDataHead[0] && !!productPassportDataHead[0]?.image_carousel?.length && (
                                            <ProductImageSlider productImageList={productPassportDataHead[0].image_carousel} />
                                        )}
                                    </div>
                                </div> :
                                null
                        }

                        <div className={`product-passport-info-display`}>
                            {
                                !isSectionOpen ?
                                    <div className="product-passport-head">
                                        {productPassportDataHead.map((headItem, index) => {
                                            const compositionData = getCompositionData(headItem);

                                            return (
                                                <div key={'head-item' + index} className="head-item">
                                                    <p className="title">{headItem.title}</p>

                                                    {headItem?.size && !isProductPassportView && (
                                                        <p className="badge" key={index}>{headItem.size}</p>
                                                    )}

                                                    {compositionData && (
                                                        <div className="composition">
                                                            {compositionData.map((comp, compIndex) => (
                                                                <p className="composition" key={compIndex}>{comp.label}: {comp.value}</p>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {headItem?.description &&
                                                        <p className="description">
                                                            <TextWithLinksParser text={headItem.description} />
                                                        </p>
                                                    }

                                                    {!!headItem.info?.length && (
                                                        <div className="shop-items">
                                                            {headItem.info?.map((item, infoIndex) =>
                                                                item.url_path && (
                                                                    <div className="info" key={infoIndex}>
                                                                        <a target="_blank" rel="noreferrer" href={item.url_path}>
                                                                            <img src={item.image} alt="" />
                                                                            <p>{item.url_name}</p>
                                                                        </a>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div> :
                                    null
                            }

                            {
                                productPassportDataCarousel.length ?
                                    <ProductPassportDataCollapsable
                                        data={productPassportDataCarousel}
                                        isProductPassportView={isProductPassportView}
                                    /> :
                                    <ProductPassportDataSection
                                        data={productPassportDataSection}
                                        isProductPassportView={isProductPassportView}
                                        isSectionOpen={isSectionOpen}
                                        setIsSectionOpen={setIsSectionOpen}
                                        setSelectedTab={setSelectedTab}
                                    />
                            }

                            <div className="scroll-top-element"
                                 onClick={() => {
                                     window[`scrollTo`]({ top: 0, behavior: `smooth` });
                                 }}>
                                <img src="/static/images/scroll-icon.svg" alt="" />
                            </div>
                        </div>
                    </>
            ) : (
                <div className={`sorry-message-wrapper`}>
                    {queryParams === null ? (
                        <div className="image-bg">
                            <div className="green-bg">
                                <div className="error-text">
                                    <p className="title">Scan the QR code on the care label</p>
                                    <p className="description">for your product passport</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="error-page">
                            <h3>Oops your Digital Product Passport is still in transit</h3>
                            {productPassportDataHead?.product && (
                                <p>
                                    <span>{productPassportDataHead?.product?.sku}</span>
                                    {!!productPassportDataHead?.product?.sku && !!productPassportDataHead?.product?.size && <span> | </span>}
                                    <span>{productPassportDataHead?.product?.size}</span>
                                </p>
                            )}
                            <p>Check back soon to trace the journey this garment has been on from fabric to factory.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
